import { defineRoutes } from '@kestrel/router';
import { isDevelop } from './mode.ts';

export const routes = defineRoutes().add({
	path: '/sandbox',
	component: () => import.meta.env.PROD ? import('./pages/404.svelte') : import('./pages/sandbox/Sandbox.svelte'),
	/*         */
	template: () => import.meta.env.PROD ? undefined : import('./templates/sandbox_template.html?raw')
})
	.add({
		path: '/signup',
		component: () => import('./pages/signup/SignUp.svelte'),
		server: () => import('./pages/signup/SignUpServer.ts')
	}).add({
		path: '/smoke/signup',
		component: () => isDevelop() ? import('./pages/signup/SignUp.svelte') : import('./pages/404.svelte'),
		server: () => isDevelop() ? import('./pages/signup/SignUpServer.ts') : undefined,
		template: () => isDevelop() ? import('./templates/assets_template.html?raw') : undefined
	}).add({
		path: '/pdp/signup',
		component: () => import('./pages/signup/PDPSignUp.svelte'),
		server: () => import('./pages/signup/PDPSignUpServer.ts')
	})
	.add({
		path: '/signup/registrationFlow',
		component: () => import('./pages/signup/registrationFlow/RegistrationSignUpFlow.svelte'),
		server: () => import('./pages/signup/registrationFlow/RegistrationSignUpFlowServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}).add({
		path: '/signup/success',
		component: () => import('./pages/signup/success/SignUpSuccessBasicSheet.svelte'),
		server: () => import('./pages/signup/success/SignUpSuccessBasicSheetServer.ts')
	}).add({
		path: '/signup/registrationFlow/success',
		component: () => import('./pages/signup/registrationFlow/success/SignUpSuccessBasicFocusDialog.svelte'),
		server: () => import('./pages/signup/registrationFlow/success/SignUpSuccessBasicFocusDialogServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}).add({
		path: '/signup/error',
		component: () => import('./pages/signup/error/SignUpErrorBasicSheet.svelte')
	}).add({
		path: '/signup/registrationFlow/error',
		component: () => import('./pages/signup/registrationFlow/error/SignUpErrorBasicFocusDialog.svelte'),
		server: () => import('./pages/signup/registrationFlow/error/SignUpErrorBasicFocusDialogServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}).add({
		path: '/signup/banner/basic',
		component: () => import('./pages/signup/banner/SignUpBanner.svelte'),
		server: () => import('./pages/signup/banner/SignUpBannerServer.ts')
	}).add({
		path: '/pointsInfoBannerSheet',
		component: () => import('./pages/points-info-banner/PointsInfoBannerSheet.svelte'),
		server: () => import('./pages/points-info-banner/PointsInfoBannerSheetServer.ts')
	}).add({
		path: '/teaser/raffle',
		component: () => import('./pages/teaser/raffle/birthday/Raffle.svelte'),
		server: () => import('./pages/teaser/raffle/birthday/RaffleServer.ts')
	}).add({
		path: '/entrypage',
		component: () => import('./pages/teaser/product/ProductTeaser.svelte'),
		server: () => import('./pages/teaser/product/ProductTeaserServer.ts')
	}).add({
		path: '/productlist',
		component: () => import('./pages/teaser/product/ProductTeaser.svelte'),
		server: () => import('./pages/teaser/product/ProductTeaserServer.ts')
	}).add({
		path: '/meinkonto',
		component: () => import('./pages/teaser/customer/CustomerTeaser.svelte'),
		server: () => import('./pages/teaser/customer/CustomerTeaserServer.ts')
	}).add({
		path: '/basket',
		component: () => import('./pages/teaser/customer/CustomerTeaser.svelte'),
		server: () => import('./pages/teaser/customer/CustomerTeaserServer.ts')
	}).add({
		path: '/retailerselection',
		component: () => import('./pages/teaser/article/RetailerSelectionTeaser.svelte'),
		server: () => import('./pages/teaser/article/RetailerSelectionTeaserServer.ts')
	}).add({
		path: '/detailview',
		component: () => import('./pages/teaser/article/DetailviewTeaser.svelte'),
		server: () => import('./pages/teaser/article/DetailviewTeaserServer.ts')
	}).add({
		path: '/servicepage',
		component: () => import('./pages/teaser/service-page/ServicePageTeaser.svelte'),
		server: () => import('./pages/teaser/service-page/ServicePageTeaserServer.ts')
	}).add({
		path: '/membership',
		component: () => import('./pages/teaser/membership/MembershipTeaser.svelte'),
		server: () => import('./pages/teaser/membership/MembershipTeaserServer.ts')
	}).add({
		path: '/pointsInfoBanner',
		component: () => import('./pages/points-info-banner/PointsInfoBanner.svelte'),
		server: () => import('./pages/points-info-banner/PointsInfoBannerServer.ts')
	}).add({
		path: '/terms-and-conditions',
		component: () => import('./pages/sheet/terms-and-conditions/TermsAndConditions.svelte')
	}).add({
		path: '/data-protection',
		component: () => import('./pages/sheet/data-protection/DataProtection.svelte')
	})
	.add({
		path: '/gateway/subscribe',
		methods: () => import('./api/gateway/Subscribe.ts')
	}).add({
		path: '/internal/health',
		methods: () => import('./api/internal/Health.ts')
	}).add({
		path: '/internal/info',
		methods: () => import('./api/internal/Info.ts')
	}).add({
		path: '/internal/prometheus',
		methods: () => import('./api/internal/Prometheus.ts')
	})
	.add({
		path: '/gateway/generateCustomerIdentityLoginUrl',
		methods: () => import('./api/gateway/GenerateCustomerIdentityLoginUrl.ts')
	})
	.add({
		path: '/gateway/generateCustomerIdentityRegistrationUrl',
		methods: () => import('./api/gateway/GenerateCustomerIdentityRegistrationUrl.ts')
	})
	.add({
		path: '/gateway/pointsInfoBannerContext',
		methods: () => import('./api/gateway/PointsInfoBannerContext.ts')
	})
	.add({
		path: '/gateway/articleTeaserContext',
		methods: () => import('./api/gateway/ArticleTeaserContext.ts')
	})
	.build();
